import React, { useCallback, useContext, useEffect, useState } from "react";
import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import styles from "./category.module.css";
import { CiSearch } from "react-icons/ci";
import CategoryModal from "../../../Components/Modals/MenuCategoryModal/CategoryModal";
import MenuApi, { CategoryApi } from "../../../App/api/menu.apis";
import { RxCrossCircled } from "react-icons/rx";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import placeHolderImage from "../../../Assets/images/image-not-available.jpg";
import { useNavigate } from "react-router";
import debounce from "lodash/debounce";
import { getAllCategory } from "./HelperCategory";
import { IoReloadSharp } from "react-icons/io5";
import AddCategory from "./AddCategory";
import { FaRegEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import ConfirmPopup from "../../../Components/ConfirmPopup";
import LoaderContext from "../../../Components/loader";
import { allRolePermission } from "../../../temp";
import DynamicCategoryForm from "./DynamicCategoryForm";

const Category = ({ meta }) => {
  const { handleLoading } = useContext(LoaderContext);
  const [addCategory, setaddCategory] = useState(false);
  const [addDynamicCategory, setAddDynamicCategory] = useState(false);
  const [editCategoryData, setEditCategoryData] = useState(null);
  const [changeStore, setChangeStore] = useState(false);
  const [venderCategoryData, setVenderCategoryData] = useState([]);
  const [searchVenderCategory, setSearchVenderCategory] = useState("");
  const [isSubCategory] = useState(true);
  const [subCategory, setSubCategory] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState(null);
  const [venderName, setVenderName] = useState(null);
  const [categoryPage, setCategoryPage] = useState(1);
  const [venderId, setVenderId] = useState(null);
  const [categoryHasMore, setCategoryHasMore] = useState(0);
  const [searchCategory, setSearchCategory] = useState("");
  const [isConfirm, setIsConfirm] = useState(false);
  const [accessCategory, setAccessCategory] = useState({
    read: false,
    add: false,
    update: false,
    delete: false,
  });

  const permission = allRolePermission;

  useEffect(() => {
    if (permission) {
      let accessRights = {
        read: false,
        add: false,
        update: false,
        delete: false,
      };

      permission.forEach((p) => {
        if (p?.component?.name === "menu_category") {
          accessRights = {
            read: p.permissions?.some((perm) => perm.permissionName === "Read"),
            add: p.permissions?.some(
              (perm) => perm.permissionName === "Create"
            ),
            update: p.permissions?.some(
              (perm) => perm.permissionName === "Update"
            ),
            delete: p.permissions?.some(
              (perm) => perm.permissionName === "Delete"
            ),
          };
        }
      });

      setAccessCategory(accessRights);
    }
  }, [permission]);

  // console.log("permissions>>>", permission);
  // console.log("accessCategory>>>", accessCategory);

  //Initial render get all categories
  const getAllCategories = async () => {
    setSubCategoryData([]);
    const res = await getAllCategory(() =>
      MenuApi.getVenderCategory({ page: 1, limit: 100, status: "Approved" })
    );
    setVenderCategoryData(res?.data?.categories);
    setCategoryHasMore(res?.data?.totalCount);
    setCategoryPage(2);
  };

  const deleteCategory = async () => {
    handleLoading(true);
    try {
      await CategoryApi.deleteCategory(editCategoryData?._id);
    } catch (err) {
      // console.log(err);
      // showBoundary(err);
    } finally {
      handleLoading(false);
      setEditCategoryData(null);
      setIsConfirm(false);
      getAllCategories();
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  const loadMoreCategory = async () => {
    const res = await getAllCategory(() =>
      MenuApi.getVenderCategory(
        {
          filter: venderId?.filter,
          page: categoryPage,
          limit: 100,
          status: "Approved",
        },
        searchCategory
      )
    );
    // console.log("res", res);
    const newData = res?.data?.categories;
    setVenderCategoryData((prev) =>
      categoryPage === 1 ? newData : [...prev, ...newData]
    );
    setCategoryHasMore(res?.data?.totalCount);
    setCategoryPage(categoryPage + 1);
  };

  const getAllVenderCategory = async (vender_id, data) => {
    setVenderId(vender_id);
    setVenderName(data);
    const res = await getAllCategory(() =>
      MenuApi.getVenderCategory({
        filter: vender_id?.filter,
        page: 1,
        limit: 100,
      })
    );
    const newData = res?.data?.categories;
    setVenderCategoryData(newData);
    setCategoryHasMore(res?.data?.totalCount);
    setCategoryPage(categoryPage + 1);
  };

  const seachCategory = async (query) => {
    let res;
    if (venderId) {
      res = await getAllCategory(() =>
        MenuApi.getVenderCategory(
          { filter: venderId?.filter, page: 1, limit: 100, status: "Approved" },
          query
        )
      );
    } else {
      res = await getAllCategory(() =>
        MenuApi.getVenderCategory({ page: 1, limit: 100 }, query)
      );
    }

    const newData = res?.data?.categories;
    setVenderCategoryData(newData);
    setCategoryHasMore(res?.data?.totalCount);
    setCategoryPage(categoryPage + 1);
  };

  const handleCategoryClick = async (item) => {
    setSubCategoryData(item);
    setSubCategory(true);
  };

  const debouncedFetch = useCallback(
    debounce((query) => {
      seachCategory(query);
      setSearchCategory(query);
    }, 1000),
    [venderId]
  );

  const debouncedSearch = (event) => {
    const query = event.target.value;
    setSearchVenderCategory(query);
    debouncedFetch(query);
  };

  return (
    <>
      <CommonLayout />
      <div className={styles.container}>
        <div className={styles.top_content}>
          <div>
            <p className={styles.p1}>
              {venderName?.first_name || "All Stores"}
              <span className={styles.span1}>
                {venderName && `(${venderName?.address})`}
              </span>
            </p>
            <div className={styles.border_search}>
              <input
                type="text"
                style={{
                  border: "none",
                  outline: "none",
                  backgroundColor: "transparent",
                }}
                value={searchVenderCategory}
                onChange={debouncedSearch}
                placeholder="Search"
              />
              <CiSearch size={"1.1rem"} />
            </div>
          </div>

          <div className="flex gap-2">
            {accessCategory.add && (
              <p
                className={styles.p2_border}
                onClick={() => setaddCategory(true)}
              >
                Add Category
              </p>
            )}
            {/* <p
                className={`${styles.p2_border}`}
                onClick={() => {
                  // console.log("Add Dynamic Category button clicked",addDynamicCategory); 
                  setAddDynamicCategory(true);
                }}
              >
                Add Category
              </p> */}
            <p
              className={styles.p2_border}
              onClick={() => setChangeStore(true)}
            >
              Change Store
            </p>
          </div>
        </div>
        <hr style={{ marginTop: "1.3rem" }} />
        <div className={`${styles.item__container}`}>
          {venderCategoryData?.length > 0 ? (
            venderCategoryData.map((item) => (
              <div
                onClick={() => handleCategoryClick(item)}
                className={`${styles.item} relative border`}
                key={item.id}
              >
                <div className=" flex absolute top-0 right-0 z-[6] gap-2">
                  {accessCategory.update && (
                    <span
                      className=" btn-border  w-10 h-10 rounded-full flex justify-center items-center text-[--color--11]"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSubCategory(false);
                        setEditCategoryData(item);
                      }}
                    >
                      <FaRegEdit className="text-[1rem]" />
                    </span>
                  )}
                  {accessCategory.delete && (
                    <span
                      className=" btn-border  w-10 h-10 rounded-full flex justify-center items-center text-[--color--11]"
                      onClick={(e) => {
                        e.stopPropagation();
                        setSubCategory(false);
                        setEditCategoryData(item);
                        setIsConfirm(true);
                      }}
                    >
                      <MdDeleteForever className="text-[1rem]" />
                    </span>
                  )}
                </div>
                {item.image ? (
                  <LazyLoadImage
                    src={item?.image}
                    // alt={item.name}
                    // loading="lazy"
                    effect="blur"
                    wrapperProps={{
                      style: { transitionDelay: ".5s" },
                    }}
                    className={styles.img}
                  />
                ) : (
                  <img src={placeHolderImage} alt="" className={styles.img} />
                )}
                <div className={styles.category_item}>
                  {/* <p className={styles.vender_name}>{item?.user?.first_name}</p> */}
                  <p className={styles.category_item_name}>{item.name}</p>
                </div>
              </div>
            ))
          ) : (
            <img src="/no-product-found.png" alt="No product found" />
          )}
          {categoryHasMore > venderCategoryData?.length && (
            <div className={styles.loadMoreBox}>
              <div
                className={styles.LoadMoreButtonContainer}
                onClick={loadMoreCategory}
              >
                <button className={styles.loadMoreButton}>Load More</button>
                <IoReloadSharp className={styles.loadMoreCategoryIcon} />
              </div>
            </div>
          )}
        </div>

        <SubCategory
          isSubCategory={isSubCategory}
          subCategoryData={subCategoryData}
          handleSubcategoryClick={(e) => console.log("e", e)}
          subCategory={subCategory}
          setSubCategory={setSubCategory}
        />
      </div>
      {changeStore && (
        <CategoryModal
          setChangeStore={setChangeStore}
          getAllVendorCategory={getAllVenderCategory}
        />
      )}
      <ConfirmPopup
        isOpen={Boolean(isConfirm)}
        onClose={() => setEditCategoryData(null)}
        onDelete={() => deleteCategory()}
        labels={{
          heading: "Are you sure?",
          paragraph: `Did you want to delete!`,
          button: "Yes",
        }}
      />
      <AddCategory
        currentItems={editCategoryData}
        open={Boolean(editCategoryData) || addCategory}
        handleClose={() => {
          setaddCategory(false);
          setEditCategoryData(null);
          getAllCategories();
        }}
      />
      {addDynamicCategory && (
        <DynamicCategoryForm onClose={() => setAddDynamicCategory(false)} />
      )}
    </>
  );
};

export default Category;

const SubCategory = ({
  isSubCategory,
  subCategoryData,
  handleSubcategoryClick,
  subCategory,
  setSubCategory,
}) => {
  const navigate = useNavigate();

  const handleSubcategoryItem = (item) => {
    navigate(`/app/menu/item/${item._id}-${item.name}`);
  };
  // console.log("subCategoryData", subCategoryData);
  return (
    <div
      className={`fixed top-0 right-0 z-50 h-full bg-white shadow-lg transition-all ${
        subCategory ? "w-96" : "w-0"
      } overflow-hidden`}
    >
      {/* Close Button */}
      <div className="absolute top-4 right-4">
        {subCategory && (
          <RxCrossCircled
            className="cursor-pointer text-gray-600 hover:text-red-500"
            size={"2.4rem"}
            onClick={() => setSubCategory(false)}
          />
        )}
      </div>

      {/* Header */}
      <div className="p-5">
        <h2 className="text-lg font-bold text-gray-700 mb-4">Sub Categories</h2>
        {subCategoryData?.image && (
          <img
            src={subCategoryData?.image}
            alt={subCategoryData?.name}
            className="w-full h-40 object-cover rounded-lg shadow-md"
          />
        )}
        <div className="mt-4">
          <p className="text-gray-800 text-lg font-semibold">
            {subCategoryData?.name}
          </p>
        </div>
      </div>

      {/* Subcategory List */}
      <div className="px-5 overflow-y-auto h-[calc(100%-200px)]">
        {subCategoryData?.subCategories?.length > 0 ? (
          subCategoryData?.subCategories.map((item) => (
            <div
              key={item._id}
              className={`flex items-center mt-2 gap-3 p-3 rounded-lg cursor-pointer transition ${
                item.is_visible
                  ? item.status === "Approved"
                    ? "hover:bg-green-100"
                    : "hover:bg-red-100"
                  : "bg-gray-100 cursor-not-allowed"
              }`}
              onClick={() => item.is_visible && handleSubcategoryItem(item)}
            >
              <div
                className={`w-4 h-4 rounded-full ${
                  item.is_visible
                    ? item.status === "Approved"
                      ? "bg-green-500"
                      : "bg-red-500"
                    : "bg-gray-400"
                }`}
              ></div>
              <p
                className={`flex-1 capitalize ${
                  item.is_visible
                    ? "text-gray-800"
                    : "text-gray-400 line-through"
                }`}
              >
                {item.name}
              </p>
              <span className="text-sm text-gray-500">{item.status}</span>
            </div>
          ))
        ) : (
          <p className="text-gray-500 mt-5">No subcategories available.</p>
        )}
      </div>
    </div>
  );
};
